import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
export const AnimatedHeightWrapper = ({ children, className }) => {
    const containerRef = useRef(null);
    const [height, setHeight] = useState('auto');
    useEffect(() => {
        if (containerRef.current) {
            const resizeObserver = new ResizeObserver(entries => {
                // We only have one entry, so we can use entries[0].
                const observedHeight = entries[0].contentRect.height;
                setHeight(observedHeight);
            });
            resizeObserver.observe(containerRef.current);
            return () => {
                // Cleanup the observer when the component is unmounted
                resizeObserver.disconnect();
            };
        }
    }, []);
    return (_jsx(Container, { className: className, style: { height }, animate: { height }, transition: { duration: 0.2 }, children: _jsx("div", { ref: containerRef, children: children }) }));
};
const Container = styled(motion.div) `
  overflow: hidden;
`;
